import React from 'react';
import { StartingRoomItemProps } from '../../interfaces/components';
import { Box, Text, Image } from '@chakra-ui/react';

function StartingRoomItem({
  gotoRoom,
  name,
  activeLocale,
  textOne,
  textTwo,
  textThree,
  textFour,
  imageUrl,
  button,
  setActive,
}: StartingRoomItemProps) {
  const onOptClick = () => {
    window.GotoScene && window.GotoScene(gotoRoom);
    setTimeout(() => {
      setActive();
    }, 500);
  };

  return (
    <Box
      height={['140px', '140px', '140px', '300px', '330px']}
      w={['100%', '320px', '360px', '230px']}
      display="flex"
      flexDirection={['row', 'row', 'row', 'column']}
      justifyContent={['center', 'center', 'center', 'space-between']}
      alignItems="center"
    >
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        height={['100%', '100%', '100%', 'unset']}
        w={['170px', '180px', '230px', '230px']}
        border={['1px solid black', '1px solid black', '1px solid black', 'unset']}
        cursor={['pointer', 'pointer', 'unset']}
        pointerEvents={['unset', 'unset', 'none']}
        onClick={onOptClick}
      >
        <Text
          fontSize={['20px', '20px', '25px', '25px', '30px']}
          lineHeight={['22px', '22px', '27px', '27px', '32px']}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
        >
          {textOne}
        </Text>
        <Text
          fontSize={['12px', '13px', '14px', '14px', '15px']}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
          fontWeight="900"
          color={name === 'indoor' ? '#186F38' : '#6482B9'}
        >
          {textTwo}
        </Text>
        <Text
          fontSize={['12px', '13px', '14px', '14px', '15px']}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
        >
          {textThree}
        </Text>
        <Text
          fontSize={['12px', '13px', '14px', '14px', '15px']}
          fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
        >
          {textFour}
        </Text>
      </Box>
      <Box
        display="flex"
        flexDirection={['column', 'column', 'column', 'column']}
        justifyContent="space-between"
        alignItems="center"
        height={['100%', '100%', '100%', 'unset']}
        w={['110px', '110px', '110px', '230px']}
      >
        <Image
          src={imageUrl}
          w={['100%', '100%', '100%', '100%', '100%']}
          height={['100%', '100%', '100%', '130px', '150px']}
          objectFit="cover"
          cursor={['pointer', 'pointer', 'unset']}
          pointerEvents={['unset', 'unset', 'none']}
          onClick={onOptClick}
        />
        <Box
          w="100%"
          border={['1px solid black', '1px solid black', '1px solid black', '2px solid black']}
          display="flex"
          justifyContent="center"
          alignItems="center"
          h={['40px']}
          _hover={{ bg: '#FFCB00' }}
          cursor="pointer"
          transition="all .5s"
          onClick={onOptClick}
        >
          <Text
            textTransform="uppercase"
            fontSize={['12px', '13px', '14px', '14px', '18px']}
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            fontWeight="900"
          >
            {button}
          </Text>
        </Box>
      </Box>
    </Box>
  );
}

export default StartingRoomItem;
